import { ofType, combineEpics } from 'redux-observable';
import { map, mergeMap } from 'rxjs/operators';

import * as rxop from 'rxjs/operators';
import { forkJoin} from 'rxjs';
import { valid } from '../api';
import store from 'approot/app/store';
import esgService from '../api/esg/esgService';
import esgConverter from '../converter/esgConverter';
import { navigate } from 'approot/redux/navAction';
import ObjectHelper from 'approot/common/lib/ObjectHelper';
import { dspAuthentication } from 'approot/epic/appEpic';
import { DSP_SESSION_IN_COOKIE, hasVerifiedDspSession } from '../common/auth/dsp';
import { confirmationPageEsgTmsTrackView } from 'approot/util/taggingUtils';

import {
	RDX_ESG_QUESTIONNAIRE_DATA,
	RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT,
	RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT_AND_PRINT,
	RDX_ESG_QUESTIONNAIRE_RESPONSES,
	RDX_ESG_QUESTIONNAIRE_RESPONSES_HISTORY,
	RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE,
	//RDX_ESG_QUESTIONNAIRE_START,
	initQuestionnaireDone,
	reportGenerate
} from '../redux/esgAction';


/* ============================== environmental social governance init data Begin ============================== */
//init page data
/**
 *
 * @param {object} action$ The action param.
 * @returns {void}
 */
const initData = (action$) =>
	action$.pipe(
		ofType(RDX_ESG_QUESTIONNAIRE_DATA),
		mergeMap(() =>
			esgService.fetchQuestionnaires_wealth().pipe(
				map((wResponse) => {
					if (valid(wResponse)) {
						const questionnaireList = esgConverter.convertResponse(wResponse);
						return initQuestionnaireDone(questionnaireList);
					}
					return { type: 'rdx/Done' };
				})
			)
		)
	);

/* ============================== environmental social governance init data End ============================== */

/**submit data */
/**
 *
 * @param {object} action$ The action param.
 * @returns {void}
 */
const submitDataAndPrintEpic = (action$) =>
	action$.pipe(
		ofType(RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT_AND_PRINT),
		mergeMap((action) =>
			esgService.responses_wealth(esgConverter.buildSubmitRequest_wealth(action.data)).pipe(
				map((wResponse) => {
					if (valid(wResponse)) {
						if (wResponse.status === 201) {
							const responseId = wResponse.response.questionnaireResponse.questionnaireResponseIdentifier;
							rxop.delay(30000);
							store.dispatch(reportGenerate(responseId));
						}
					}
					return { type: 'rdx/Done' };
				})
			)
		)
	);

const authenticateAfterBusinessError = response => {
	if (hasVerifiedDspSession()) {
		valid(response);
		return;
	}
	Promise.resolve(dspAuthentication()).then(result => {
		if (result === DSP_SESSION_IN_COOKIE) {
			valid(response);
		}
	}, () => valid(response));
};

const submitDataEpic = (action$) =>
	action$.pipe(
		ofType(RDX_ESG_QUESTIONNAIRE_DATA_SUBMIT),
		mergeMap((action) =>
			esgService.responses_wealth(esgConverter.buildSubmitRequest_wealth(action.data)).pipe(
				map((wResponse) => {
					if (wResponse.status === 401 || wResponse.status === 403) {
						authenticateAfterBusinessError(wResponse);
						return { type: 'rdx/Done' };
					}
					if (valid(wResponse)) {
						if (wResponse.status === 201) {
							rxop.delay(30000);
						}
					}
					confirmationPageEsgTmsTrackView();
					return navigate('esgHome');
				})
			)
		)
	);

const isActiveQuestionnaire = () => Boolean(sessionStorage.getItem('prePage')) &&
	(window.location.href.split('#')[1] || '').split('?')[0].replace(/\/+$/, '') === '/esg';

/**retrieve questionnaire result*/
/**
 *
 * @param {object} action$ The action param.
 * @returns {object} The questionnaire result.
 */
const retrieveResultDataEpic = (action$) =>
	action$.pipe(
		ofType(RDX_ESG_QUESTIONNAIRE_RESPONSES),
		mergeMap((action) =>
			forkJoin(
				//esgService.retrieveLogon(),
				esgService.retrieveQuestionnairesResult_wealth(esgConverter.buildRetrieveResponsesRequest_wealth(action.data)),
				esgService.fetchQuestionnaires_wealth()).
				pipe(
					map((wResponses) => {
						const wResponse1 = wResponses[1];
						if (wResponse1.status === 401 || wResponse1.status === 403) {
							authenticateAfterBusinessError(wResponse1);
							return { type: 'rdx/Done' };
						}
						if (valid(wResponses[1])) {
							const questionnaireList = esgConverter.convertResponse(wResponses[1]);
							store.dispatch(initQuestionnaireDone(questionnaireList));
						}
						let wResponse = wResponses[0];
						if (wResponse.status === 200) {
							let questionnaireResult = esgConverter.convertQuestionnaireResults(wResponse.response);
							//if no records for customer, will show questionnaire as first page
							if (!isActiveQuestionnaire()) {
								if (ObjectHelper.isNullOrlengthZore(questionnaireResult.historyList)) {
									return navigate('esgStart');
								}
								store.dispatch({ type: RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE, questionnaireResult });
							}
						}else{
							valid(wResponse);
							return navigate('esgStart');
						}
						return { type: 'rdx/Done' };
					})
				)
		)
	);

/**retrieve questionnaire result*/
/**
 *
 * @param {object} action$ The action param.
 * @returns {object} The questionnaire result.
 */
const retrieveHistoryResultDataEpic = (action$) =>
	action$.pipe(
		ofType(RDX_ESG_QUESTIONNAIRE_RESPONSES_HISTORY),
		mergeMap((action) =>
			esgService.retrieveQuestionnairesResult_wealth(esgConverter.buildRetrieveResponsesRequest_wealth(action.data)).
				pipe(
					map((wResponse) => {
						if (valid(wResponse)) {
							if (wResponse.status === 200) {
								let questionnaireResult = esgConverter.convertQuestionnaireResults(wResponse.response);
								//if no records for customer, will show questionnaire as first page
								if (ObjectHelper.isNullOrlengthZore(questionnaireResult.historyList)) {
									return navigate('esg');
								}
								store.dispatch({ type: RDX_ESG_QUESTIONNAIRE_RESPONSES_DONE, questionnaireResult });
							}
						}
						return { type: 'rdx/Done' };
					})
				)
		)
	);

const esgEpic = combineEpics(initData, submitDataEpic, submitDataAndPrintEpic, retrieveResultDataEpic, retrieveHistoryResultDataEpic);

export default esgEpic;
